import { stReportSdk } from './report';

/**
 * 记录页面加载时间
 */
stReportSdk.trackPageLoad();



// WEBPACK FOOTER //
// ./src/$$tracker/track-page-load.js